export const CircularDotIcon = props => (
  <svg width='4' height='4' viewBox='0 0 4 4' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M1.99906 4.008C1.55106 4.008 1.16706 3.852 0.847063 3.54C0.527063 3.22 0.367063 2.832 0.367063 2.376C0.367063 1.92 0.527063 1.536 0.847063 1.224C1.16706 0.904 1.55106 0.744 1.99906 0.744C2.45506 0.744 2.84306 0.904 3.16306 1.224C3.48306 1.536 3.64306 1.92 3.64306 2.376C3.64306 2.832 3.48306 3.22 3.16306 3.54C2.84306 3.852 2.45506 4.008 1.99906 4.008Z'
      fill='#808080'
    />
  </svg>
);
